<script>
import options from './CheckoutContent.options'
export default options
</script>

<template>
  <article class="kb-checkout-content">

    <div class="kb-checkout-content__wrapper">

      <div class="kb-checkout-content__wrapper-left">

        <ol class="kb-checkout-content__step-indicator">

          <template v-for="(step, index) in checkoutSteps" :key="index">
            <li class="kb-checkout-content__step-indicator-list-item">

              <button :aria-current="step?.active ? 'step' : null" @click="handleStepClick(step.stepNumber)" class="kb-checkout-content__step-indicator-link">

                <h3 class="kb-checkout-content__step-indicator-title">{{ step.stepTitle }}</h3>

                <div class="kb-checkout-content__step-indicator-circle"
                  :class="{ 'kb-checkout-content__step-indicator-circle--active-step': step?.active }">
                  <p class="kb-checkout-content__step-indicator-number"><span class="kb-visually-hidden">step</span>{{ step.stepNumber }}<span class="kb-visually-hidden">ud af {{ checkoutSteps.length }}</span></p>
                </div>

                
              </button>

            </li>
          </template>

        </ol>

        <h2 class="kb-checkout-content__title" aria-live="polite">{{ activeStep.stepTitle }}</h2>

        <component :is="determineCheckoutStepContent()" ></component>

      </div>

      <div class="kb-checkout-content__wrapper-aside">
        <BasketAside :miniBasket='true' />
      </div>
    </div>

  </article>
</template>

